var exports = {
  "kL": "ChannelWebhooksTab.module__container___OFh2Rn",
  "wx": "ChannelWebhooksTab.module__header___OFh2Rn",
  "h_": "ChannelWebhooksTab.module__description___OFh2Rn",
  "UD": "ChannelWebhooksTab.module__buttonContainer___OFh2Rn",
  "dc": "ChannelWebhooksTab.module__spinnerContainer___OFh2Rn",
  "Xb": "ChannelWebhooksTab.module__messageBox___OFh2Rn",
  "PQ": "ChannelWebhooksTab.module__webhooksList___OFh2Rn",
  "wp": "ChannelWebhooksTab.module__followedSection___OFh2Rn",
  "Gf": "ChannelWebhooksTab.module__sectionTitle___OFh2Rn",
  "yV": "ChannelWebhooksTab.module__sectionDescription___OFh2Rn",
};

module.exports = exports;
